/**
 * @generated SignedSource<<2bf5ee35b3aa2b97c5095de69d8f3772>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptModalPublicClipQuery$variables = {
  clipId: string;
};
export type TranscriptModalPublicClipQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_PublicClipModal_clip">;
  } | null;
  readonly viewer: {
    readonly videoPlaybackSettings: {
      readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_PublicClipModal_videoPlaybackSettings">;
    };
  };
};
export type TranscriptModalPublicClipQuery = {
  response: TranscriptModalPublicClipQuery$data;
  variables: TranscriptModalPublicClipQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clipId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "clipId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "RecordingAttendee",
  "kind": "LinkedField",
  "name": "attendees",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v6/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTopUser",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptModalPublicClipQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TranscriptModal_PublicClipModal_clip"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserVideoPlaybackSettings",
            "kind": "LinkedField",
            "name": "videoPlaybackSettings",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TranscriptModal_PublicClipModal_videoPlaybackSettings"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranscriptModalPublicClipQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clipEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clipStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transcript",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingRecordedVideoUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "ownerAccount",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowRecapDownload",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isZeroDayRetentionEnabled",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "baseRecording",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordingVideoDeletionReason",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mediaType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingRecordedVideoPosterUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingRecordedVideoDuration",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFavourite",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasTranscript",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transcriptTxtDownloadUrl",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userVideoProgress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "didViewerAttend",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "meetingCallEnd",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aiArtifactsTxtDownloadUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingSummary",
                        "kind": "LinkedField",
                        "name": "activeSummary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TranscriptChapter",
                            "kind": "LinkedField",
                            "name": "chapters",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TranscriptBulletPoint",
                                "kind": "LinkedField",
                                "name": "bulletPoints",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "textShort",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "context",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingKeyEvent",
                        "kind": "LinkedField",
                        "name": "meetingKeyEvents",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "participantName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeFromRecordingStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endTimeFromRecordingStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "duration",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingCommentsData",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "threadId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startTimestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endTimestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "count",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isExternal",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canRegenerateSummary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showLowLanguageConfidenceRegenerationBanner",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "type": "MeetingRecording",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecording",
                        "kind": "LinkedField",
                        "name": "baseRecording",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MeetingRecordingClip",
                    "abstractKey": null
                  }
                ],
                "type": "MeetingRecordingInterface",
                "abstractKey": "__isMeetingRecordingInterface"
              }
            ],
            "type": "MeetingRecordingClip",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserVideoPlaybackSettings",
            "kind": "LinkedField",
            "name": "videoPlaybackSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "playbackRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtitlesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "volume",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "muted",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "473df6f901f8d54ff598f2a0073e41b4",
    "id": null,
    "metadata": {},
    "name": "TranscriptModalPublicClipQuery",
    "operationKind": "query",
    "text": "query TranscriptModalPublicClipQuery(\n  $clipId: ID!\n) {\n  node(id: $clipId) {\n    __typename\n    ...TranscriptModal_PublicClipModal_clip\n    id\n  }\n  viewer {\n    videoPlaybackSettings {\n      ...TranscriptModal_PublicClipModal_videoPlaybackSettings\n      id\n    }\n    id\n  }\n}\n\nfragment Timeline_meetingKeyEvents on MeetingRecording {\n  meetingKeyEvents {\n    eventType\n    participantName\n    timeFromRecordingStart\n    endTimeFromRecordingStart\n    duration\n  }\n  comments {\n    threadId\n    startTimestamp\n  }\n}\n\nfragment TranscriptModal_PublicClipModal_clip on MeetingRecordingClip {\n  id\n  clipEnd\n  clipStart\n  summary\n  title\n  transcript\n  meetingRecordedVideoUrl\n  ownerAccount {\n    __typename\n    name\n    logo\n    allowRecapDownload\n    isZeroDayRetentionEnabled\n    id\n  }\n  baseRecording {\n    meetingRecordingVideoDeletionReason\n    id\n  }\n  mediaType\n  meetingRecordedVideoPosterUrl\n  meetingRecordedVideoDuration\n  ... on MeetingRecordingInterface {\n    __isMeetingRecordingInterface: __typename\n    ...TranscriptVideo_meetingRecording_1JfjPu\n    ...TranscriptPanel_Transcript_meetingRecording_1JfjPu\n  }\n  ...utils_useGetURL_recording\n}\n\nfragment TranscriptModal_PublicClipModal_videoPlaybackSettings on UserVideoPlaybackSettings {\n  ...TranscriptVideo_videoPlaybackSettings\n}\n\nfragment TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1JfjPu on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  transcript\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    attendees {\n      fullName\n      email\n      image\n      isTopUser\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      attendees {\n        fullName\n        email\n        image\n        isTopUser\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_TranscriptSegment_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  id\n  ownerAccount {\n    __typename\n    id\n  }\n  ...utils_useGetURL_recording\n}\n\nfragment TranscriptPanel_Transcript_meetingRecording_1JfjPu on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    activeSummary {\n      id\n    }\n    canRegenerateSummary\n    comments {\n      threadId\n      startTimestamp\n      endTimestamp\n      count\n      users {\n        id\n        email\n        fullName\n        image\n        isExternal\n      }\n    }\n    showLowLanguageConfidenceRegenerationBanner\n  }\n  ownerAccount {\n    __typename\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_meetingRecording\n  ...Timeline_meetingKeyEvents\n  ...TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1JfjPu\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1JfjPu\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n}\n\nfragment TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  transcript\n  ownerAccount {\n    __typename\n    id\n  }\n}\n\nfragment TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1JfjPu on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    attendees {\n      fullName\n      email\n      image\n      isTopUser\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      attendees {\n        fullName\n        email\n        image\n        isTopUser\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptVideo_meetingRecording_1JfjPu on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  ... on MeetingRecording {\n    userVideoProgress\n    didViewerAttend\n  }\n  ...Video_meetingRecording\n}\n\nfragment TranscriptVideo_videoPlaybackSettings on UserVideoPlaybackSettings {\n  id\n  playbackRate\n  subtitlesEnabled\n  volume\n  muted\n}\n\nfragment Video_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  createdAt\n  isFavourite\n  hasTranscript\n  meetingRecordedVideoUrl\n  transcriptTxtDownloadUrl\n  meetingRecordedVideoPosterUrl\n  mediaType\n  ... on MeetingRecording {\n    meetingCallEnd\n    aiArtifactsTxtDownloadUrl\n    activeSummary {\n      chapters {\n        timestamp\n        title\n        bulletPoints {\n          text\n          timestamp\n          textShort\n          context\n        }\n      }\n      id\n    }\n    ...Timeline_meetingKeyEvents\n  }\n}\n\nfragment utils_useGetURL_recording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  ... on MeetingRecording {\n    id\n  }\n  ... on MeetingRecordingClip {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "31b48dea2af7f3295f69cc819a55631b";

export default node;
